<script setup>
import { RouterView, useRoute } from 'vue-router'
import menuMain from './components/layout/menu-main.vue'
import headerMain from './components/layout/HeaderComponent.vue'
import ExportLoader from './components/export/ExportLoader.vue'
import 'vue3-toastify/dist/index.css'
import { ref } from 'vue'

const route = useRoute()
const isMobileMenuOpen = ref(false)

const handleMobileMenuToggle = (value) => {
  isMobileMenuOpen.value = value
}

</script>

<template>
  <ExportLoader />

  <div v-if="route.meta.hideLayout" class="h-screen">
    <RouterView :key="route.fullPath" />
  </div>

  <div v-else class="flex h-screen overflow-hidden">
    <menuMain :is-mobile-menu-open="isMobileMenuOpen" />
    <div class="flex-1 flex flex-col overflow-hidden">
      <div class="flex-shrink-0">
        <headerMain @toggle-mobile-menu="handleMobileMenuToggle" />
      </div>

      <div class="flex-1 overflow-y-auto py-4 px-4 md:px-10 md:pt-10">
        <RouterView :key="route.fullPath" />
      </div>
    </div>
  </div>

</template>

<style scoped>
.bg-gradient {
  background-image: linear-gradient(to bottom, #385660, #49707E, #3A5762);
}

.toast-container {
  position: fixed;
  top: 1rem;
  right: 1rem;
  z-index: 9999;
}
</style>
